// Google Sheets API 연동을 위한 유틸리티 함수

// Google Apps Script 웹 앱 URL
// .env 파일에서 읽어오거나 직접 입력
// Google Apps Script 웹 앱 URL
const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL || 'https://script.google.com/macros/s/AKfycbytp_pqj7JBcibM9DZO9GtqsMspHThwerLiOG9JAHsUkxXsPmPYs_Tf-LYka5mh8JfBxQ/exec';

export const saveToGoogleSheets = async (formData) => {
  try {
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors', // CORS 우회
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        timestamp: new Date().toISOString()
      })
    });

    // no-cors 모드에서는 response를 읽을 수 없으므로 성공으로 간주
    return { success: true };
  } catch (error) {
    console.error('Google Sheets 저장 실패:', error);
    return { success: false, error: error.message };
  }
};

export const updatePaymentStatus = async (email, paymentInfo) => {
  try {
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'updatePayment',
        email: email,
        paymentStatus: '결제완료',
        paymentDate: new Date().toISOString(),
        paymentInfo: paymentInfo
      })
    });

    return { success: true };
  } catch (error) {
    console.error('결제 상태 업데이트 실패:', error);
    return { success: false, error: error.message };
  }
};